import { Outlet } from "react-router-dom";
import LanguageSelector from "./language-selector/LanguageSelector";
import LateralMenu from "./lateral-menu/LateralMenu";
import { useUserStore } from "@/store/useUser";

const Layout = () => {
  const { isSupervisor } = useUserStore();

  if (isSupervisor) {
    return (
      <div className="grid grid-cols-[auto_1fr] h-full min-h-0 max-w-full">
        <LateralMenu />
        <section className="grid grid-rows-[auto_1fr] h-full min-h-0 max-w-full bg-white">
          <LanguageSelector />
          <Outlet />
        </section>
      </div>
    );
  }

  return (
    <section className="grid grid-rows-[auto_1fr] h-full min-h-0 max-w-full bg-white">
      <LanguageSelector />
      <Outlet />
    </section>
  );
};

export default Layout;
